// @flow

// decodeURIComponent might rise expections, this utility
// makes it safe
const safeDecode = (str) => {
  if (!str) return str
  const strWithoutPlus = str.replace(/\+/g, ' ')

  try {
    return decodeURIComponent(strWithoutPlus)
  } catch (e) {
    return strWithoutPlus
  }
}

/**
 * In the past, react-router-dom provided
 * an object with the query params as a prop
 * but that is not longer the case. So this
 * function receives a query string like
 * ?param=value&other_param=value
 * and return an Object like:
 * { some_param: value, other_param: value }
 * @param  {String} search
 * @return {Object}
 */

const queryStringToObject = (search: string): Object => {
  const hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((result, hash) => {
    const [key, val] = hash.split('=')
    if (!key.trim()) return result
    return { ...result, [key]: safeDecode(val) }
  }, {})
}

export default queryStringToObject
